import { MIN_PASSWORD_LENGTH } from '../../../../../../shared/utils/authUtils'
import { emailRegex } from '../../../../../../shared/utils/formattingUtils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const FIELDS_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.Email,
  FormFieldNamesEnum.Password,
  FormFieldNamesEnum.PPMerchantId
]

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [FormFieldNamesEnum.Email]: val => {
    if (!val) { return 'Required' }
    if (!emailRegex.test(val)) { return 'Invalid email format' }
    return null
  },
  [FormFieldNamesEnum.Password]: val => {
    if (!val) { return 'Required' }
    if (val.length < MIN_PASSWORD_LENGTH) { return 'Too short' }
    return null
  },
  [FormFieldNamesEnum.PPMerchantId]: val => {
    if (!val) { return 'Required' }
    return null
  }
}
